import React from "react";
import { ICommonIconProps } from "../interface";

const MenuIcon = ({ ...props }: ICommonIconProps) => {
  return (
    <svg
      width={props?.IconWidth || "30"}
      height={props?.IconHeight || "30"}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 6C7.5 5.1716 8.1716 4.5 9 4.5H28.5C29.3284 4.5 30 5.1716 30 6C30 6.8284 29.3284 7.5 28.5 7.5H9C8.1716 7.5 7.5 6.82834 7.5 6ZM28.5 13.5H1.5C0.671602 13.5 0 14.1717 0 15C0 15.8284 0.671602 16.5 1.5 16.5H28.5C29.3284 16.5 30 15.8284 30 15C30 14.1717 29.3284 13.5 28.5 13.5ZM28.5 22.5H15C14.1717 22.5 13.5 23.1716 13.5 24C13.5 24.8283 14.1717 25.5 15 25.5H28.5C29.3284 25.5 30 24.8283 30 24C30 23.1716 29.3284 22.5 28.5 22.5Z"
        fill={props?.IconColor || "currentColor"}
      />
    </svg>
  );
};

export default MenuIcon;
